'use client';

import { Grid } from '@sbercloud/uikit-product-site-grid';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { PropsWithChildren } from 'react';

import { useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/root/src/hooks';

export function CardsGrid({ children }: PropsWithChildren) {
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  return (
    <Grid
      columnsConfig={{
        desktop: {
          amount: 3,
          minWidth: 0,
        },
        desktopSmall: {
          amount: 2,
          minWidth: 0,
        },
        tablet: {
          amount: 2,
          minWidth: 0,
        },
        mobile: {
          amount: 1,
          minWidth: 0,
        },
      }}
      layoutType={layoutType}
    >
      {children}
    </Grid>
  );
}
